import { Link, useLocation } from 'react-router-dom'
import './navWeb.css'
import { useState, useEffect } from 'react';
import details from"../dataStore/details.json"

export default function NavWeb (){

    const location = useLocation()
    const path = location.pathname.substring(1)

    const [pageScroll, setpageScroll] = useState(false);
    const handleScroll = () => {
        const position = window.scrollY;
        if (position >= 100) {
            setpageScroll(true) 
        } else {
            setpageScroll(false) 
        }
      };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return(
        <>
        <nav className='navContainer'>
            <div className={pageScroll?'navweb navScrolled':'navweb'}>
                <figure>
                    <Link to='/'>
                        {/* <img src='./images/logo.svg' alt='Zion Cab'/> */}
                        <h2>{details.name}</h2>
                    </Link>                
                </figure>
                <main>
                    <Link to='/' className={path===''?'indicator menuItem':'menuItem'}>Home</Link>
                    <Link to='/tariff' className={path==='tariff'?'indicator menuItem':'menuItem'}>Tariff</Link>
                    <Link to='/contact' className={path==='contact'?'indicator menuItem':'menuItem'}>Contact Us</Link>
                </main>  
                <a href={`tel:+91${details.primary_phone}`}>
                    <figure>
                        <img src='./images/call.png' alt='Call'/>
                    </figure>                    
                    <p>{details.primary_phone}</p>
                </a>              
            </div>                                    
        </nav>
        </>
    )
}